import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import DropIn from "braintree-web-drop-in-react";
import axios from "axios";
import Loader from "react-loader-spinner";
import { withCookies } from "react-cookie"; // Use withCookies from react-cookie
import ls from "local-storage";
import { options } from "../../config/options";
import Congratulations from "./Congratulations";

class PremiumPayment extends Component {
  constructor(props) {
    super(props); // Call super(props) to initialize 'this.props'
    this.state = {
      buybutton: "buybutton",
      clientToken: null,
      api_url: localStorage.getItem("api_url") || "", // Handle case where localStorage.getItem("api_url") is null
      lang: ls.get("LangKeySet") || options[0],
      langKey: ls.get("LangValue") || "",
      user_details: {},
      openCon: false,
    };

    this.openCongratulation = this.openCongratulation.bind(this);
    this.closeCongratulation = this.closeCongratulation.bind(this);
    this.navigateToapp = this.navigateToapp.bind(this);
    this.getprofile = this.getprofile.bind(this); // Bind getprofile method
  }

  componentDidMount() {
    const { cookies } = this.props;

    if (cookies.get("onboarded") !== "true") {
      this.props.history.push("/login");
    }

    axios.get(`${this.state.api_url}generateclienttoken`).then((res) => {
      if (res.data.token) {
        this.setState({
          clientToken: res.data.token,
        });
      }

      // Adjusted setTimeout to set state correctly after clientToken is fetched
      setTimeout(() => {
        if (!this.state.clientToken) {
          this.setState({
            buybutton: "buybutton",
          });
        } else {
          this.setState({
            buybutton: "buybuttonshow",
          });
        }
      }, 2000);
    });

    this.getprofile(); // Call getprofile method
  }

  getprofile() {
    let data = new FormData();
    data.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    data.append("language", this.state.langKey);

    axios({
      method: "post",
      url: `${this.state.api_url}webprofile`,
      data: data,
      headers: { "Content-Type": "multipart/form-data" }, // Correctly set headers
    }).then((res) => {
      if (res.data.status !== false) {
        const user_details = res.data.result;

        this.setState({
          user_details: user_details,
          loc: user_details.location,
        });
      } else {
        this.props.history.push("/login");
      }
    });
  }

  openCongratulation() {
    this.setState({
      openCon: true,
    });
  }

  closeCongratulation() {
    this.setState({
      openCon: false,
    });
  }

  navigateToapp() {
    this.props.history.push("/app");
  }

  buy = async () => {
    const { nonce } = await this.instance.requestPaymentMethod();
    
    if (nonce) {
      this.setState({
        buybutton: "buybutton",
      });
    }

    var payment = new FormData();
    payment.append("pay_nonce", nonce);
    payment.append("price", JSON.parse(localStorage.getItem("premium_price")));
    payment.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    payment.append("premium_id", JSON.parse(localStorage.getItem("selected_premium")));
    payment.append("currency_code", JSON.parse(localStorage.getItem("currency")));
    payment.append("language", this.state.langKey);

    axios({
      method: "post",
      url: `${this.state.api_url}webpaypremium`,
      data: payment,
      headers: { "Content-Type": "multipart/form-data" }, // Correctly set headers
    }).then((res) => {
      localStorage.removeItem("selected_premium");
      localStorage.removeItem("premium_price");

      if (res.data.status === "true") {
        localStorage.setItem("premium_popup", "1");
        this.openCongratulation();
      } else {
        this.props.history.push("/nonpremiumuser");
      }
    });
  };

  render() {
    const style = {
      zIndex: 10,
      backgroundColor: "white",
      height: "100vh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      overflowY: "hidden",
    };

    if (this.state.clientToken) {
      return (
        <div className="peopleShowHolder">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "90vh",
              justifyContent: "center",
            }}
          >
            <DropIn
              options={{
                authorization: this.state.clientToken,
                paypal: { flow: "vault" }
              }}
              onInstance={(instance) => (this.instance = instance)}
            />
            {this.state.clientToken && (
              <button
                className={this.state.buybutton}
                onClick={this.buy}
              >
                <Trans i18nKey="Buy">Buy</Trans>
              </button>
            )}
          </div>
          <Congratulations
            user={this.state.user_details}
            navigate={this.navigateToapp}
            open={this.state.openCon}
          />
        </div>
      );
    } else {
      return (
        <div>
          <div className="loder-icon">
            <div style={style} id="loader">
              <Loader type="Bars" color="#32A5D2" height={30} width={50} />
            </div>
          </div>
        </div>
      );
    }
  }
}

export default withCookies(withTranslation()(PremiumPayment));
